import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import useOnboardingSx from '../../hooks/useOnboardingSx';

export default function PermissionModuleAccordion({
  title,
  enabledCount,
  totalCount,
  defaultExpanded = false,
  children,
}) {
  const sx = useOnboardingSx();

  return (
    <Accordion
      disableGutters
      elevation={0}
      defaultExpanded={defaultExpanded}
      sx={{
        ...sx.permissionPanel,
        '&:before': { display: 'none' },
        '& + &': { mt: 1.5 },
      }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={sx.permissionModuleSummary}>
        <Typography variant="subtitle2" fontWeight={600} sx={{ flex: 1 }}>
          {title}
        </Typography>
        <Chip
          size="small"
          label={`${enabledCount}/${totalCount} enabled`}
          sx={sx.permissionCountChip}
        />
      </AccordionSummary>
      <AccordionDetails sx={sx.permissionModuleDetails}>{children}</AccordionDetails>
    </Accordion>
  );
}
